export default __webpack_public_path__ + "55ff4f8ddf06e80a9f81454b8418a933.png";